import { render } from "./Radios.vue?vue&type=template&id=0513841a&scoped=true"
import script from "./Radios.vue?vue&type=script&lang=js"
export * from "./Radios.vue?vue&type=script&lang=js"

import "./Radios.vue?vue&type=style&index=0&id=0513841a&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0513841a"]])

export default __exports__